import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import {
  Container,
  Form,
  Button,
  Divider,
  Panel,
  Message,
  toaster,
  Input,
  PasswordInput,
  HStack,
} from "rsuite";
import moment from "moment/moment";
import { useState } from "react";
import { confApp } from "../CONF_APP";
import axios from "../axiosIn";

export const App = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [loading, setLoading] = useState(false);
  const [negocio, setNegocio] = useState("");
  const [codNegocio, setCodNegocio] = useState("");
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");

  const setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  const handleSubmit = async () => {
    var url ='Login';

    setLoading(true);
    const data = {
      codNegocio: codNegocio,
      user: usuario,
      pwd: password,
    };

    await axios
    .post(url, data)
      .then((res) => {
        if (res.data === 0) {
          setLoading(false);
          toast("Los datos de inicio de sesión, no son correctos.", "warning");
          return;
        }

        if (res.data === -1) {
          setLoading(false);
          toast("El usuario se encuentra inactivo.", "warning");
          return;
        }

        if (res.data === -2) {
          setLoading(false);
          toast("El usuario no cuenta con permisos para la aplicación.", "warning");
          return;
        }

        const auth = {
          id: res.data.id,
          codNegocio: codNegocio,
          idUser: res.data.idUser,
          idMedico: res.data.idMedico,
          medico: res.data.medico,
          idEnf: res.data.idEnf,
          enfermera: res.data.enfermera,
          nefro: res.data.nefro,
          consultorio: res.data.consultorio,
          nombre: res.data.nombre,
          sesionIni: new Date().toISOString(),
          fecha: res.data.fecha,
          permisos: res.data.permisos,
          confApp: res.data.confApp
        };

        sessionStorage.setItem("menu", JSON.stringify(res.data.menu));
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("auth", JSON.stringify(auth));
        var userUniq = `${res.data.id}${res.data.idUser}`;
        setCookie("user", userUniq, 16);
        setLoading(false);
        window.location = `/#/App/Home`;
      })
      .catch((err) => {
        setLoading(false);
        toast("Ocurrio un error al iniciar sesión", "error");
        console.error(err);
      });
  };

  const handleInput = (e) => {
    setCodNegocio(e);
  };

  const getNegocio = async () => {
    var url = `Login/getNegocio/${codNegocio}`;
    await axios.get(url).then((nxt) => {
      setNegocio(nxt);
    });
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <Container>
      {!isMobile ? (
        <HStack style={{ verticalAlign: "center" }}>
          <div className="col-lg-5 col-md-5 col-sm-5">
            <Panel
              bordered
              shaded
              style={{ height: "100vh", padding: "100px", paddingTop: "180px" }}
            >
              <center>
                <Image src="/Images/Logo.png" style={{ height: 220 }} />
              </center>
              <div>
                <Form fluid onSubmit={handleSubmit}>
                  <Form.Group>
                    <Input
                      name="codNegocio"
                      value={codNegocio}
                      placeholder="Código de Negocio"
                      style={{ borderColor: '#08086E'}}
                      onChange={(e) => handleInput(e)}
                      required
                    />
                  </Form.Group>

                  <Form.Group>
                    <Input
                      name="name"
                      placeholder="Usuario"
                      style={{ borderColor: '#08086E'}}
                      onChange={(e) => setUsuario(e)}
                      onFocus={() => getNegocio()}
                      value={usuario}
                      required
                    />
                  </Form.Group>

                  <Form.Group>
                    <PasswordInput
                      name="password"
                      value={password}
                      style={{ borderColor: '#08086E'}}
                      placeholder="Contraseña"
                      onChange={(e) => setPassword(e)}
                      required
                    />
                  </Form.Group>

                  <br></br>

                  <Button
                    appearance="primary"
                    loading={loading}
                    block
                    type="submit"
                  >
                    Ingresar
                  </Button>
                </Form>

                <br></br>

                <Divider style={{ fontSize: "12px", color: "#CCCACA" }}>
                  <b>Version: {confApp.VERSION}</b>
                </Divider>
                <center>
                  <a
                    href="https://www.radyxxa.com.mx"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "blue",
                      textDecoration: "none",
                      fontSize: "9px",
                    }}
                  >
                    Designed by &nbsp;<i>RADYXXA</i>
                  </a>
                </center>
              </div>
            </Panel>
          </div>
          <div className="col-lg-7 col-md-7 col-sm-7">
            <Image
              src="Images/backLogin.jpg"
              style={{ objectFit: "cover", height: "100vh", width: "100%" }}
            ></Image>
          </div>
        </HStack>
      ) : (
        <Panel
          bordered
          shaded
          style={{ height: "100vh", paddingBottom: "25%", paddingTop: "25%" }}
        >
          <center>
            <Image src="/Images/Logo.png" style={{ height: 100 }} />
          </center>
          <br></br>
          <center>{negocio}</center>
          <br></br>
          <div>
            <Form fluid onSubmit={handleSubmit}>
              <Form.Group>
                <Input
                  name="codNegocio"
                  value={codNegocio}
                  placeholder="Código de Negocio"
                  onChange={(e) => handleInput(e)}
                  required
                />
              </Form.Group>

              <Form.Group>
                <Input
                  name="name"
                  placeholder="Usuario"
                  onChange={(e) => setUsuario(e)}
                  onFocus={() => getNegocio()}
                  value={usuario}
                  required
                />
              </Form.Group>

              <Form.Group>
                <PasswordInput
                  name="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e)}
                  required
                />
              </Form.Group>

              <br></br>

              <Button
                appearance="ghost"
                loading={loading}
                block
                type="submit"
              >
                Ingresar
              </Button>
            </Form>

            <br></br>

            <Divider style={{ fontSize: "12px", color: "#CCCACA" }}>
              <b>Version: {confApp.VERSION}</b>
            </Divider>
            <center>
              <a
                href="https://www.radyxxa.com.mx"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "blue",
                  textDecoration: "none",
                  fontSize: "9px",
                }}
              >
                Designed by &nbsp;<i>RADYXXA</i>
              </a>
            </center>
          </div>
        </Panel>
      )}
    </Container>
  );
};
